// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"_1NWgA7GLnBnFpxPRvInq95","dialog":"_2CT7ArrsT0VvrIncpaJomy","header-delete":"_7FIEjGyNypIXC-vFElH9G"};